import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import axios from 'axios';

const API = 'https://app.b3rastreamento.com.br/api';

const OPERADORAS = [
  { nome: 'Claro M2M', apn: 'claro.com.br', usuario: 'claro', senha: 'claro' },
  { nome: 'Vivo M2M', apn: 'zap.vivo.com.br', usuario: 'vivo', senha: 'vivo' },
  { nome: 'TIM M2M', apn: 'tim.br', usuario: 'tim', senha: 'tim' },
  { nome: 'Simple ARQIA', apn: 'simple.br', usuario: 'arqia', senha: 'arqia' },
  { nome: 'Simplepm Algar', apn: 'simplepm.algar.br', usuario: 'algar', senha: 'algar' },
  { nome: 'Algar IoT', apn: 'algar.br', usuario: 'algar', senha: 'algar' },
];

const rotuloStatusLinha = { ativa: 'Ativa', inativa: 'Inativa', suspensa: 'Suspensa' };

function exportarLinhasPDF(lista, tituloFiltro) {
  const NL = String.fromCharCode(10);
  const linhasHtml = lista.map(l => [
    '<tr>',
    '<td>' + (l.simcard || '-') + '</td>',
    '<td>' + (l.numero || '-') + '</td>',
    '<td>' + (l.operadora || '-') + '</td>',
    '<td>' + (l.apn || '-') + '</td>',
    '<td>' + (l.equipamento_serial || '-') + '</td>',
    '<td>' + rotuloStatusLinha[l.status === 'suspensa' ? 'suspensa' : (l.status === 'ativa' ? 'ativa' : 'inativa')] + '</td>',
    '</tr>'
  ].join('')).join(NL);

  const conteudo = [
    '<html><head><meta charset="utf-8"><title>Linhas GPRS</title><style>',
    'body { font-family: Arial, sans-serif; font-size: 12px; color: #333; padding: 20px; }',
    'h1 { color: #1D9E75; font-size: 18px; margin-bottom: 4px; }',
    'p { color: #999; font-size: 11px; margin-bottom: 20px; }',
    'table { width: 100%; border-collapse: collapse; }',
    'th { background: #1D9E75; color: white; padding: 8px 10px; text-align: left; font-size: 11px; }',
    'td { padding: 8px 10px; border-bottom: 1px solid #eee; font-size: 11px; }',
    'tr:nth-child(even) td { background: #f9f9f9; }',
    '.footer { margin-top: 20px; text-align: center; color: #999; font-size: 10px; }',
    '</style></head><body>',
    '<h1>Linhas GPRS' + (tituloFiltro ? ' — ' + tituloFiltro : '') + '</h1>',
    '<p>Gerado em ' + new Date().toLocaleString('pt-BR') + ' — ' + lista.length + ' linha' + (lista.length !== 1 ? 's' : '') + ' — Desenvolvido por Digital Mais BR</p>',
    '<table><thead><tr><th>SIM Card</th><th>Número</th><th>Operadora</th><th>APN</th><th>Equipamento</th><th>Status</th></tr></thead>',
    '<tbody>' + linhasHtml + '</tbody></table>',
    '<div class="footer">Desenvolvido por Digital Mais BR — digitalmaisbr.com.br</div>',
    '</body></html>'
  ].join(NL);

  const janela = window.open('', '_blank');
  janela.document.write(conteudo);
  janela.document.close();
  janela.focus();
  setTimeout(() => janela.print(), 500);
}

function exportarLinhasCSV(lista) {
  const NL = String.fromCharCode(10);
  const BOM = String.fromCharCode(0xFEFF);
  const esc = (v) => '"' + (v || '').toString().split('"').join('""') + '"';
  const linhasTexto = [
    'SIM Card,Numero,Operadora,APN,Equipamento,Status',
    ...lista.map(l => {
      const status = rotuloStatusLinha[l.status === 'suspensa' ? 'suspensa' : (l.status === 'ativa' ? 'ativa' : 'inativa')];
      return [l.simcard, l.numero, l.operadora, l.apn, l.equipamento_serial, status].map(esc).join(',');
    })
  ];
  const blob = new Blob([BOM + linhasTexto.join(NL)], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'linhas_' + new Date().toISOString().slice(0,10) + '.csv';
  a.click();
}

function Linhas() {
  const [sidebarAberta, setSidebarAberta] = useState(false);
  const [linhas, setLinhas] = useState([]);
  const [equipamentos, setEquipamentos] = useState([]);
  const [targets, setTargets] = useState([]);
  const [modalAberto, setModalAberto] = useState(false);
  const [busca, setBusca] = useState('');
  const [salvando, setSalvando] = useState(false);
  const [linhaSelecionada, setLinhaSelecionada] = useState(null);
  const [filtroStatus, setFiltroStatus] = useState(null);
  const [form, setForm] = useState({
    simcard: '', numero: '', operadora: '', apn: '', apn_usuario: '', apn_senha: '', equipamento_id: '', status: 'ativa'
  });

  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => {
    carregarLinhas();
    carregarEquipamentos();
    carregarTargets();
  }, []);

  const carregarLinhas = async () => {
    try {
      const res = await axios.get(`${API}/linhas`, { headers });
      setLinhas(res.data);
    } catch (err) { console.error(err); }
  };

  const carregarEquipamentos = async () => {
    try {
      const res = await axios.get(`${API}/equipamentos`, { headers });
      setEquipamentos(res.data);
    } catch (err) { console.error(err); }
  };

  const carregarTargets = async () => {
    try {
      const res = await axios.get(`${API}/targets`, { headers });
      setTargets(res.data);
    } catch (err) { console.error(err); }
  };

  const selecionarOperadora = (nome) => {
    const op = OPERADORAS.find(o => o.nome === nome);
    if (op) setForm(f => ({ ...f, operadora: op.nome, apn: op.apn, apn_usuario: op.usuario, apn_senha: op.senha }));
    else setForm(f => ({ ...f, operadora: nome }));
  };

  const salvar = async () => {
    if (!form.simcard) return alert('SIM Card é obrigatório!');
    setSalvando(true);
    try {
      if (linhaSelecionada) {
        await axios.put(`${API}/linhas/${linhaSelecionada.id}`, form, { headers });
      } else {
        await axios.post(`${API}/linhas`, form, { headers });
      }
      fecharModal();
      carregarLinhas();
    } catch (err) { alert('Erro ao salvar linha'); }
    setSalvando(false);
  };

  const editar = (linha) => {
    setLinhaSelecionada(linha);
    setForm({
      simcard: linha.simcard || '',
      numero: linha.numero || '',
      operadora: linha.operadora || '',
      apn: linha.apn || '',
      apn_usuario: linha.apn_usuario || '',
      apn_senha: linha.apn_senha || '',
      equipamento_id: linha.equipamento_id || '',
      status: linha.status || 'ativa'
    });
    setModalAberto(true);
  };

  const deletar = async (linha) => {
    // Verifica se o equipamento vinculado tem target
    if (linha.equipamento_id) {
      const temTarget = targets.some(t => t.equipamento_id === linha.equipamento_id);
      if (temTarget) {
        alert('⚠️ O equipamento desta linha ainda está vinculado a um veículo (target).\n\nPara remover, siga a ordem:\n1️⃣ Remova o veículo (Targets)\n2️⃣ Remova a linha (aqui)\n3️⃣ Depois remova o equipamento');
        return;
      }
    }
    if (!window.confirm(`Deseja remover a linha ${linha.simcard}?`)) return;
    try {
      await axios.delete(`${API}/linhas/${linha.id}`, { headers });
      carregarLinhas();
    } catch (err) {
      const msg = err.response?.data?.erro || 'Erro ao remover linha';
      alert(`⚠️ ${msg}`);
    }
  };

  const fecharModal = () => {
    setModalAberto(false);
    setLinhaSelecionada(null);
    setForm({ simcard: '', numero: '', operadora: '', apn: '', apn_usuario: '', apn_senha: '', equipamento_id: '', status: 'ativa' });
  };

  const efetivoStatusLinha = (l) => l.status === 'suspensa' ? 'suspensa' : (l.status === 'ativa' ? 'ativa' : 'inativa');

  const mudarStatusLinha = async (linha, novoStatus) => {
    try {
      await axios.put(`${API}/linhas/${linha.id}`, { ...linha, status: novoStatus }, { headers });
      carregarLinhas();
    } catch (err) { alert('Erro ao atualizar status'); }
  };

  const totalAtivas = linhas.filter(l => efetivoStatusLinha(l) === 'ativa').length;
  const totalInativas = linhas.filter(l => efetivoStatusLinha(l) === 'inativa').length;
  const totalSuspensas = linhas.filter(l => efetivoStatusLinha(l) === 'suspensa').length;

  const linhasFiltradas = linhas.filter(l => {
    const buscaOk = !busca ||
      l.simcard?.toLowerCase().includes(busca.toLowerCase()) ||
      l.numero?.includes(busca) ||
      l.operadora?.toLowerCase().includes(busca.toLowerCase()) ||
      l.equipamento_serial?.toLowerCase().includes(busca.toLowerCase()) ||
      l.veiculo_placa?.toLowerCase().includes(busca.toLowerCase()) ||
      l.veiculo_nome?.toLowerCase().includes(busca.toLowerCase()) ||
      l.cliente_nome?.toLowerCase().includes(busca.toLowerCase());
    const statusOk = !filtroStatus || efetivoStatusLinha(l) === filtroStatus;
    return buscaOk && statusOk;
  });

  // Equipamentos já vinculados a uma linha (exceto o atual em edição)
  const equipamentosVinculados = linhas
    .filter(l => l.equipamento_id && (!linhaSelecionada || l.id !== linhaSelecionada.id))
    .map(l => l.equipamento_id);

  const equipamentosDisponiveis = equipamentos.filter(e => !equipamentosVinculados.includes(e.id));

  const inputStyle = { width: '100%', padding: '10px 12px', border: '1.5px solid #e0e0e0', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box', outline: 'none' };
  const labelStyle = { display: 'block', marginBottom: '4px', color: '#555', fontSize: '13px', fontWeight: '500' };

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5' }}>
      <Sidebar aberta={sidebarAberta} setAberta={setSidebarAberta} />

      <div style={{ background: '#1D9E75', padding: '0 24px', height: '60px', display: 'flex', alignItems: 'center', gap: '16px', position: 'fixed', top: 0, left: 0, right: 0, zIndex: 50, boxShadow: '0 2px 10px rgba(0,0,0,0.2)' }}>
        <button onClick={() => setSidebarAberta(!sidebarAberta)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '22px', color: 'white' }}>☰</button>
        <span style={{ color: 'white', fontWeight: '700', fontSize: '18px' }}>📡 Linhas GPRS</span>
        <span style={{ color: 'rgba(255,255,255,0.7)', fontSize: '14px' }}>({linhas.length} cadastradas)</span>
      </div>

      <div style={{ paddingTop: '80px', padding: '80px 24px 24px' }}>
        <div style={{ background: '#FFF3CD', borderRadius: '8px', padding: '12px 16px', marginBottom: '16px', fontSize: '13px', color: '#856404' }}>
          ⚠️ <strong>Ordem de remoção:</strong> Primeiro remova o Veículo (Targets), depois a Linha GPRS e por último o Equipamento.
        </div>

        {/* Contadores — clique pra filtrar */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px', marginBottom: '24px' }}>
          {[
            { label: 'Total de linhas', valor: linhas.length, cor: '#1D9E75', chave: null },
            { label: '✅ Ativas', valor: totalAtivas, cor: '#22C55E', chave: 'ativa' },
            { label: '🟡 Suspensas', valor: totalSuspensas, cor: '#F59E0B', chave: 'suspensa' },
            { label: '❌ Inativas', valor: totalInativas, cor: '#EF4444', chave: 'inativa' },
          ].map(card => (
            <div key={card.label} onClick={() => setFiltroStatus(filtroStatus === card.chave ? null : card.chave)}
              style={{
                background: 'white', borderRadius: '12px', padding: '20px', cursor: 'pointer',
                boxShadow: filtroStatus === card.chave ? `0 0 0 2px ${card.cor}, 0 2px 8px rgba(0,0,0,0.06)` : '0 2px 8px rgba(0,0,0,0.06)',
                borderLeft: `4px solid ${card.cor}`, transition: 'box-shadow 0.15s'
              }}>
              <div style={{ fontSize: '28px', fontWeight: '700', color: card.cor }}>{card.valor}</div>
              <div style={{ fontSize: '13px', color: '#666', marginTop: '4px' }}>{card.label}</div>
            </div>
          ))}
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', gap: '12px', flexWrap: 'wrap' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: '1 1 400px' }}>
            <input placeholder="🔍 Buscar por SIMCARD, número, placa, serial ou cliente..." value={busca} onChange={e => setBusca(e.target.value)} style={{ ...inputStyle, width: '400px' }} />
            {filtroStatus && (
              <span style={{ fontSize: '12px', color: '#666' }}>
                Filtrando: <strong>{rotuloStatusLinha[filtroStatus]}</strong>{' '}
                <button onClick={() => setFiltroStatus(null)} style={{ background: 'none', border: 'none', color: '#1D9E75', cursor: 'pointer', fontSize: '12px', textDecoration: 'underline' }}>limpar</button>
              </span>
            )}
          </div>
          <div style={{ display: 'flex', gap: '8px' }}>
            <button onClick={() => exportarLinhasPDF(linhasFiltradas, filtroStatus ? rotuloStatusLinha[filtroStatus] : null)} style={{ background: '#E6F1FB', color: '#185FA5', border: 'none', borderRadius: '8px', padding: '10px 16px', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}>📄 Exportar PDF</button>
            <button onClick={() => exportarLinhasCSV(linhasFiltradas)} style={{ background: '#E1F5EE', color: '#0F6E56', border: 'none', borderRadius: '8px', padding: '10px 16px', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}>📥 Exportar Excel</button>
            <button onClick={() => setModalAberto(true)} style={{ background: '#1D9E75', color: 'white', border: 'none', borderRadius: '8px', padding: '10px 20px', cursor: 'pointer', fontSize: '14px', fontWeight: '600' }}>+ Nova Linha</button>
          </div>
        </div>

        <div style={{ background: 'white', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#f8f8f8' }}>
                {['SIM Card', 'Número', 'Operadora', 'APN', 'Equipamento', 'Status', 'Ações'].map(h => (
                  <th key={h} style={{ padding: '14px 16px', textAlign: 'left', fontSize: '13px', color: '#666', fontWeight: '600', borderBottom: '1px solid #eee' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {linhasFiltradas.length === 0 ? (
                <tr><td colSpan="7" style={{ padding: '48px', textAlign: 'center', color: '#999' }}>
                  <div style={{ fontSize: '48px', marginBottom: '12px' }}>📡</div>
                  <div>Nenhuma linha cadastrada</div>
                </td></tr>
              ) : linhasFiltradas.map((l, i) => {
                const temTarget = l.equipamento_id && targets.some(t => t.equipamento_id === l.equipamento_id);
                return (
                  <tr key={i} style={{ borderBottom: '1px solid #f0f0f0' }}
                    onMouseEnter={e => e.currentTarget.style.background = '#f9f9f9'}
                    onMouseLeave={e => e.currentTarget.style.background = 'white'}>
                    <td style={{ padding: '14px 16px', fontSize: '12px', fontFamily: 'monospace', fontWeight: '600' }}>{l.simcard}</td>
                    <td style={{ padding: '14px 16px', fontSize: '14px', color: '#666' }}>{l.numero}</td>
                    <td style={{ padding: '14px 16px', fontSize: '14px', fontWeight: '500' }}>{l.operadora}</td>
                    <td style={{ padding: '14px 16px', fontSize: '12px', color: '#666', fontFamily: 'monospace' }}>{l.apn}</td>
                    <td style={{ padding: '14px 16px', fontSize: '13px', color: '#666' }}>
                      {equipamentos.find(e => e.id === l.equipamento_id)?.serial || '—'}
                    </td>
                    <td style={{ padding: '14px 16px' }}>
                      {(() => { const st = efetivoStatusLinha(l); const cores = { ativa: ['#E1F5EE', '#0F6E56'], suspensa: ['#FFF3CD', '#856404'], inativa: ['#FCEBEB', '#A32D2D'] }; return (
                        <span style={{ background: cores[st][0], color: cores[st][1], padding: '4px 10px', borderRadius: '20px', fontSize: '12px', fontWeight: '500' }}>
                          {rotuloStatusLinha[st]}
                        </span>
                      ); })()}
                    </td>
                    <td style={{ padding: '14px 16px' }}>
                      <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                        <button onClick={() => editar(l)} style={{ background: '#E6F1FB', color: '#185FA5', border: 'none', borderRadius: '6px', padding: '6px 10px', cursor: 'pointer', fontSize: '12px', fontWeight: '500' }}>✏️</button>
                        <select value={efetivoStatusLinha(l)} onChange={e => mudarStatusLinha(l, e.target.value)}
                          style={{ border: '1px solid #ddd', borderRadius: '6px', padding: '6px 8px', fontSize: '12px', background: 'white', cursor: 'pointer' }}>
                          <option value="ativa">✅ Ativa</option>
                          <option value="suspensa">🟡 Suspensa</option>
                          <option value="inativa">❌ Inativa</option>
                        </select>
                        <button onClick={() => deletar(l)}
                          style={{ background: temTarget ? '#f0f0f0' : '#FCEBEB', color: temTarget ? '#999' : '#A32D2D', border: 'none', borderRadius: '6px', padding: '6px 10px', cursor: 'pointer', fontSize: '12px', fontWeight: '500' }}
                          title={temTarget ? 'Remova o veículo vinculado primeiro' : 'Remover linha'}>
                          🗑️
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {modalAberto && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: 'white', borderRadius: '16px', padding: '32px', width: '560px', maxHeight: '85vh', overflowY: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
              <h2 style={{ margin: 0, color: '#333' }}>{linhaSelecionada ? '✏️ Editar Linha' : '➕ Nova Linha GPRS'}</h2>
              <button onClick={fecharModal} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#999' }}>×</button>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
              <div style={{ gridColumn: '1/-1' }}>
                <label style={labelStyle}>SIM Card ICCID *</label>
                <input style={inputStyle} value={form.simcard} onChange={e => setForm({ ...form, simcard: e.target.value })} placeholder="Ex: 89550180800017752932" />
              </div>
              <div>
                <label style={labelStyle}>Número</label>
                <input style={inputStyle} value={form.numero} onChange={e => setForm({ ...form, numero: e.target.value })} placeholder="+55 (12) 976133625" />
              </div>
              <div>
                <label style={labelStyle}>Status</label>
                <select style={inputStyle} value={form.status} onChange={e => setForm({ ...form, status: e.target.value })}>
                  <option value="ativa">Ativa</option>
                  <option value="suspensa">Suspensa</option>
                  <option value="inativa">Inativa</option>
                </select>
              </div>
              <div style={{ gridColumn: '1/-1' }}>
                <label style={labelStyle}>Operadora (APN preenchido automaticamente)</label>
                <select style={inputStyle} value={form.operadora} onChange={e => selecionarOperadora(e.target.value)}>
                  <option value="">Selecione a operadora</option>
                  {OPERADORAS.map(o => <option key={o.nome} value={o.nome}>{o.nome}</option>)}
                </select>
              </div>
              <div>
                <label style={labelStyle}>APN</label>
                <input style={{ ...inputStyle, background: '#f9f9f9' }} value={form.apn} onChange={e => setForm({ ...form, apn: e.target.value })} placeholder="apn.operadora.com.br" />
              </div>
              <div>
                <label style={labelStyle}>APN Usuário</label>
                <input style={{ ...inputStyle, background: '#f9f9f9' }} value={form.apn_usuario} onChange={e => setForm({ ...form, apn_usuario: e.target.value })} />
              </div>
              <div style={{ gridColumn: '1/-1' }}>
                <label style={labelStyle}>APN Senha</label>
                <input style={{ ...inputStyle, background: '#f9f9f9' }} value={form.apn_senha} onChange={e => setForm({ ...form, apn_senha: e.target.value })} />
              </div>
              <div style={{ gridColumn: '1/-1' }}>
                <label style={labelStyle}>Vincular Equipamento</label>
                <select style={inputStyle} value={form.equipamento_id} onChange={e => setForm({ ...form, equipamento_id: e.target.value })}>
                  <option value="">Selecione o equipamento (opcional)</option>
                  {equipamentosDisponiveis.map(e => (
                    <option key={e.id} value={e.id}>{e.serial} — {e.modelo}</option>
                  ))}
                </select>
                {equipamentos.length !== equipamentosDisponiveis.length && (
                  <div style={{ fontSize: '11px', color: '#999', marginTop: '4px' }}>
                    {equipamentos.length - equipamentosDisponiveis.length} equipamento(s) já vinculado(s) a outras linhas não são exibidos.
                  </div>
                )}
              </div>
            </div>

            {form.apn && (
              <div style={{ background: '#E1F5EE', borderRadius: '8px', padding: '12px', marginTop: '16px' }}>
                <span style={{ color: '#0F6E56', fontSize: '13px' }}>✅ APN <strong>{form.apn}</strong> preenchido automaticamente para <strong>{form.operadora}</strong></span>
              </div>
            )}

            <div style={{ display: 'flex', gap: '12px', marginTop: '24px', justifyContent: 'flex-end' }}>
              <button onClick={fecharModal} style={{ padding: '10px 20px', border: '1.5px solid #ddd', borderRadius: '8px', background: 'white', cursor: 'pointer', fontSize: '14px' }}>Cancelar</button>
              <button onClick={salvar} disabled={salvando} style={{ padding: '10px 24px', background: salvando ? '#ccc' : '#1D9E75', color: 'white', border: 'none', borderRadius: '8px', cursor: salvando ? 'not-allowed' : 'pointer', fontSize: '14px', fontWeight: '600' }}>
                {salvando ? 'Salvando...' : linhaSelecionada ? 'Atualizar' : 'Salvar'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Linhas;